import '@vanilla-extract/css/vanilla.virtual.css?ve-css=LnZ0ZTlmejAgewogIGNvbG9yOiBpbmhlcml0OwogIHRleHQtZGVjb3JhdGlvbjogbm9uZTsKfQ';
export var overlayLinkStyle = 'vte9fz0';